import {IconProp} from '@fortawesome/fontawesome-svg-core';
import {faAlarmClock} from '@fortawesome/pro-regular-svg-icons/faAlarmClock';
import {faImage} from '@fortawesome/pro-regular-svg-icons/faImage';
import {faLightbulb} from '@fortawesome/pro-regular-svg-icons/faLightbulb';
import {faMessageLines} from '@fortawesome/pro-regular-svg-icons/faMessageLines';
import {faPen} from '@fortawesome/pro-regular-svg-icons/faPen';
import {faQuoteRight} from '@fortawesome/pro-regular-svg-icons/faQuoteRight';
import {faTriangleExclamation} from '@fortawesome/pro-regular-svg-icons/faTriangleExclamation';
import {faUserCheck} from '@fortawesome/pro-regular-svg-icons/faUserCheck';

export enum MeaInfoEnum {
  warning = 'warning',
  example = 'example',
  note = 'note',
  important = 'important',
  advice = 'advice',
  good_to_know = 'good_to_know',
  reminder = 'reminder',
  illustration = 'illustration',
  old = 'old',
  expert_advice = 'expert_advice',
  default = 'default',
}

export const MeaInfoValues = Object.values(MeaInfoEnum);

type MeaInfos = {
  icon: IconProp | null;
  color: string;
};

export const MeaInfoColors: Record<MeaInfoEnum, MeaInfos> = {
  warning: {
    icon: faTriangleExclamation,
    color: '#EF4444',
  },
  example: {
    icon: faQuoteRight,
    color: '#059669',
  },
  note: {
    icon: faPen,
    color: '#0EA5E9',
  },
  important: {
    icon: faTriangleExclamation,
    color: '#BE185D',
  },
  advice: {
    icon: faMessageLines,
    color: '#3B83F6',
  },
  good_to_know: {
    icon: faLightbulb,
    color: '#F59E0B',
  },
  reminder: {
    icon: faAlarmClock,
    color: '#F97316',
  },
  illustration: {
    icon: faImage,
    color: '#6D28D9',
  },
  old: {
    icon: faAlarmClock,
    color: '#ff615e',
  },
  expert_advice: {
    icon: faUserCheck,
    color: '#5FAD56',
  },
  default: {
    icon: null,
    color: '#6B7280',
  },
};
